// web环境http请求
/*
 * @Author: wyh
 * @Date: 2020-04-20 21:15:20
 * @Last Modified by: wyh
 * @Last Modified time: 2020-04-23 11:02:05
 */
import axios from 'axios'
import qs from 'qs'
import { Toast } from 'vant'
import { baseURL, getTenantId } from './commonParams'
import {getApiHost} from './getApiHost.js'
import { ABNORMAL_MSG } from '@/const/prompt'
import router from '../router'
// axios.defaults.withCredentials=true
const apiHost = getApiHost()
// 创建axios实例
const service = axios.create({
  baseURL: baseURL, // process.env.BASE_API, // api 的 base_url
  timeout: 15000, // 请求超时时间
  withCredentials: true
})
const pending = [] // 声明一个数组用于存储每个ajax请求的取消函数和ajax标识
const CancelToken = axios.CancelToken
const removePending = (ever) => {
  for (const p in pending) {
    if (pending[p].u === ever.url + '&' + ever.method) { // 当当前请求在数组中存在时执行函数体
      pending[p].f() // 执行取消操作
      pending.splice(p, 1) // 把这条记录从数组中移除
    }
  }
}
// request拦截器
service.interceptors.request.use(
  config => {
    config.headers['Content-Type'] = config['Content-Type'] || 'application/x-www-form-urlencoded'
    // removePending(config) // 在一个ajax发送前执行一下取消操作
    config.cancelToken = new CancelToken((c) => {
      // 这里的ajax标识我是用请求地址&请求方式拼接的字符串，当然你可以选择其他的一些方式
      pending.push({ u: config.url + '&' + config.method, f: c })
    })
    // todo 登录相关接口
    if (!config.data) config.data = {}
    config.method = config.method || 'post'
    config.data.tenantId = config.data.tenantId || getTenantId()
    config.data.channel = config.data.channel || 'h5'
    // auth改造 代驾接口增加参数domainType=200
    config.data.domainType = 200
    if(config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
      config.data = qs.stringify(config.data);
    }
    return config
  },
  error => {
    console.warn('request error', error)
    Promise.reject(error)
  }
)
// response 拦截器
service.interceptors.response.use(
  response => {
    const res = response
    // removePending(res.config)
    console.log('axios response:', response)
    const netWork = window.navigator.onLine
    const interUrl = response.config.url
    if (!res) {
      console.warn('response error:', response)
      if (interUrl && interUrl.indexOf('log/unicorn/event') !== -1) {
        return Promise.reject(res)
      }
      Toast({
        message: !netWork ? ABNORMAL_MSG.NETWORK_OFFLINE : ABNORMAL_MSG.SERVER_ERROR,
        duration: 3 * 1000
      })
      return Promise.reject(res)
    }else if (res.data.code == 1006) {
      const innerApps = sessionStorage.getItem('innerApps')
      if  (innerApps == 1) {
        return Promise.resolve(res)
      } else {
        // 获取跳转各渠道参数
        const urlParams = JSON.parse(localStorage.getItem('allParams'))
        // 通用获取租户id
        const tenantId = localStorage.getItem('tenantId')
        const spInfo = localStorage.getItem('spInfo') ? JSON.parse(localStorage.getItem('spInfo')) : {}
        const { spLogo, spName } = spInfo || {}
        if (!localStorage.getItem(tenantId + 'token')) {
          if (urlParams && urlParams.subSource){
            if (urlParams.subSource == 'H5_GD_UNION') {
              Object.keys(urlParams).forEach(item => item.indexOf('carTeamId') !== -1 ? localStorage.removeItem(item) : '');
            }
            router.push({ path: '/login', query: { tenantId, ...urlParams, spName, spLogo } })
          } else {
            router.push({ path: '/login', query: { tenantId, spName, spLogo } })
          }
        } else {
          Toast('登录过期，请重新登录')
          if (urlParams && urlParams.subSource){
            if (urlParams.subSource == 'H5_GD_UNION') {
              Object.keys(urlParams).forEach(item => item.indexOf('carTeamId') !== -1 ? localStorage.removeItem(item) : '');
            }
            router.push({ path: '/login', query: { tenantId, ...urlParams, spName, spLogo  } })
          } else {
            router.push({ path: '/login', query: { tenantId, spName, spLogo } })
          }
        }
      }
    }
    return Promise.resolve(res)
  },
  error => {
    const netWork = window.navigator.onLine
    console.warn('response error2:', error)
    return Promise.reject(error)
  }
)
//  封装get方法,返回promise对象
export function get (url, params = {}) {
  const realUrl = apiHost + url
  return new Promise((resolve, reject) => {
    service.get(realUrl, {
      params
    })
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// 封装post请求
export function post (url, data = {}, headers) {
  const realUrl = apiHost + url
  return new Promise((resolve, reject) => {
    service.post(realUrl, data, headers)
      .then(response => {
        resolve(response.data)
      }, err => {
        reject(err)
      })
  })
}

